<template>
  <div v-resize="onResize" class="fill-height accent" ref="start-scroll">
    <div class="fill-height">
      <v-dialog
        v-if="!$vuetify.breakpoint.mdAndUp"
        width="700px"
        v-model="dialogJobDetail"
        :fullscreen="!$vuetify.breakpoint.mdAndUp"
      >
        <v-card tile flat>
          <JobDetail
            :job="jobSelectedDetail"
            :loading="loadingJob"
            @closeJobDetail="closeJobDetail"
            :error="isJobDetailError"
            :user="usuario"
          ></JobDetail>
        </v-card>
      </v-dialog>
      <v-navigation-drawer
        v-model="openFilters"
        :permanent="windowSize.x > 694"
        app
        clipped
        fixed
        width="300"
        touchless
        disable-resize-watcher
        :width="$vuetify.breakpoint.xlOnly
          ? '450'
          : $vuetify.breakpoint.lgAndUp
            ? '350'
              : windowSize.x > 694 && windowSize.x < 960
                ? '250'
                : windowSize.x > 1100 && windowSize.x < 2000
                  ? '300' : '350'"
      >
        <div class="py-4">
          <div class="px-6">
            <p class="display-1 font-weight-bold">Filtros</p>
            <v-text-field
              v-model="keyword"
              label="Puesto, empresa o palabra clave"
              filled
              :disabled="loading"
              rounded
              full-width
              dense
              prepend-inner-icon="mdi-magnify"
              hide-details
              @keypress.enter="addKeyword()"
            ></v-text-field>
            <div class="mt-4">
              <v-chip
                v-for="(keyword, index) of searchKeywords"
                :key="index"
                close
                label
                :disabled="loading"
                close-icon="mdi-close"
                class="mr-2 mb-2 primary--text font-weight-bold py-1"
                color="deep-orange lighten-5"
                @click:close="deleteKeyword(index)"
                style="white-space: normal; height: auto"
              >
                {{ keyword.id === 'permitir_discapacitados' ? 'Apto postulantes con discapacidad' : keyword.valor }}
              </v-chip>
            </div>
          </div>
          <v-expansion-panels class="mt-3" style="padding-right: 1px" accordion flat tile multiple :disabled="loading">
            <v-expansion-panel v-for="(filter, index) of filtersComputed" :key="index">
              <v-expansion-panel-header class="font-weight-bold">{{ filter.nombre }}</v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-list-item
                  v-for="(value, index) of filter.valores"
                  style="min-height: auto"
                  :key="index"
                  @click="addFilter(filter.id, value._id)"
                  :disabled="loading"
                >
                  <v-list-item-content class="py-1">
                    <v-list-item-title
                      v-if="filter.nombre !== 'Postulantes con discapacidad' && filter.nombre !== 'Fecha de publicación'"
                      v-text="value._id"
                    ></v-list-item-title>
                    <v-list-item-title
                      v-else-if="filter.nombre === 'Postulantes con discapacidad'"
                      v-text="value._id ? 'Apto' : 'No apto'"
                    ></v-list-item-title>
                    <v-list-item-title
                      v-else-if="filter.nombre === 'Fecha de publicación'"
                      v-text="timeElapsed(value._id)"
                    ></v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action
                    class="my-0 caption grey--text d-flex justify-end"
                  >({{ value.total }})</v-list-item-action>
                </v-list-item>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
      </v-navigation-drawer>
      <v-content v-if="loading" class="fill-height">
        <v-progress-linear indeterminate></v-progress-linear>
        <v-container :fluid="$vuetify.breakpoint.lgAndDown" class="px-5 pt-2">
          <v-row>
            <v-col>
              <BaseMyCard
                class="ma-2 pb-4 px-5 py-8 mb-4"
                v-for="n in 3"
                :key="n"
              >
                <v-skeleton-loader
                  ref="skeleton"
                  type="text"
                  class="px-4"
                ></v-skeleton-loader>
                <v-skeleton-loader
                  ref="skeleton"
                  type="text"
                  class="px-4"
                  width="200"
                ></v-skeleton-loader>
                <v-skeleton-loader
                  ref="skeleton"
                  type="list-item-avatar-three-line"
                ></v-skeleton-loader>
              </BaseMyCard>
            </v-col>
          </v-row>
        </v-container>
      </v-content>
      <v-content v-else class="fill-height accent">
        <v-container :fluid="$vuetify.breakpoint.lgAndDown" class="pa-0">
          <v-row>
            <v-col class="pa-0">
              <CoursesBanner />
            </v-col>
          </v-row>
          <v-row class="px-5">
            <v-col class="pb-0 d-flex pl-5 pr-9">
              <v-btn v-if="windowSize.x < 695" text @click="openFilters = true">
                <v-icon class="mr-2">mdi-filter</v-icon>Filtros
              </v-btn>
            </v-col>
          </v-row>
          <v-row class="px-5">
            <v-col class="pb-0 d-flex pl-5 pr-9">
              <v-spacer></v-spacer>
              <span class="d-flex align-center grey--text text--darken-4 font-weight-light">
                Mostrando
                <span class="primary--text font-weight-bold mx-1">{{ itemPerPage }}</span>
                a
                <span class="primary--text font-weight-bold mx-1">{{ limitPerpage }}</span>
                de
                <span
                  class="primary--text font-weight-bold ml-1"
                >{{ jobsTotal }} empleos</span>
              </span>
            </v-col>
          </v-row>
          <v-row class="px-5">
            <v-col v-if="jobs.length" class="pt-0">
              <CardNotice
                v-for="job in jobs"
                :key="job._id"
                :job="job"
                :jobSelected="jobSelected"
                :to="{ name: 'jobs by id', params: { id: job._id }, query: $route.query }"
                :user="usuario"
                class="mb-4"
              ></CardNotice>
            </v-col>
            <v-col v-else class="pt-0">
              <BaseMyCard
                class="ma-2 px-5 py-4 mb-3 d-flex align-center"
                style="cursor: auto"
              >
                <v-icon size="60" class="mr-4" color="error">mdi-card-bulleted-off-outline</v-icon>
                <span class="headline font-weight-light">Ups, no encontramos lo que estabas buscando.</span>
              </BaseMyCard>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pt-0">
              <v-pagination
                v-if="totalPages"
                v-model="page"
                :length="totalPages"
                :total-visible="6"
                @input="changePage"
              ></v-pagination>
            </v-col>
          </v-row>
        </v-container>
      </v-content>
      <v-navigation-drawer
        v-if="$vuetify.breakpoint.mdAndUp"
        v-model="openDetailJob"
        :permanent="windowSize.x > 1113"
        app
        disable-route-watcher
        right
        clipped
        :width="windowSize.x > 1400
          ? windowSize.x * 0.4
          : windowSize.x < 1113
            ? '600' : windowSize.x * 0.32"
        fixed
        mobile-break-point="1113"
        touchless
        disable-resize-watcher
      >
        <JobDetail
          :job="jobSelectedDetail"
          :loading="loadingJob"
          @closeJobDetail="closeJobDetail"
          :error="isJobDetailError"
          :user="usuario"
        ></JobDetail>
      </v-navigation-drawer>
    </div>
  </div>
</template>

<script>
import CardNotice from "@/components/CardNotice";
import CoursesBanner from "@/components/CoursesBanner";
import JobDetail from "@/components/JobDetail";
import { mapActions, mapState } from "vuex";
import { windowSizeMixin } from "@/mixin/windowSizeMixin.js";
import store from "@/store";

export default {
  mixins: [windowSizeMixin],
  components: {
    CardNotice,
    CoursesBanner,
    JobDetail
  },
  props: {
    id: {
      type: String,
    },
  },
  data() {
    return {
      loading: false,
      page: 1,
      limit: 10,
      jobSelected: undefined,
      jobSelectedDetail: undefined,
      loadingJob: false,
      dialogJobDetail: false,
      drawer: false,
      openDetailJob: false,
      openFilters: false,
      searchKeywords: [],
      keyword: '',
      isJobDetailError: false,
    };
  },
  computed: {
    ...mapState("job", ["jobs", "filters", "jobsTotal"]),
    ...mapState("postulants/postulant", ["usuario"]),
    filtersComputed() {
      // return this.filters
      //   .map(filter => ({ ...filter, valores: filter.valores
      //     .filter(valor => !this.searchKeywords
      //       .find(keyword => keyword.id === filter.id && keyword.valor === valor._id)) }));
      
      return this.filters
        .filter(filter => filter.valores.length)
        .filter(filter => !this.searchKeywords
          .find(keyword => keyword.id === filter.id )
        );
    },
    itemPerPage() {
      return this.jobs.length ? this.limit * this.page - this.limit + 1 : 0;
    },
    limitPerpage() {
      return this.jobs.length < this.limit
        ? this.jobsTotal
        : this.limit * this.page;
    },
    totalPages() {
      return Math.ceil(this.jobsTotal / this.limit);
    }
  },
  watch: {
    openDetailJob(value) {
      if (!value) {
        this.closeJobDetail();
      }
    },
    id() {
      if (this.id) this.selectJob(this.id);
    }
  },
  created() {
    this.getPageEvents();

    const jobId = this.$route.params.id;
    if (jobId) this.selectJob(jobId);
    
    const filtersKey = Object.keys(this.$route.query).filter(parameter => parameter.includes('filter'));
    const searchKeywords = filtersKey
      .map(key => key.replace('filter[', '').replace(']', ''));
    
    this.searchKeywords = searchKeywords
      .filter(key => key !== 'all')
      .map(key => ({ id: key, valor: this.$route.query[`filter[${key}]`] }));
    
    const searchToAllFields = searchKeywords
      .find(key => key === 'all');

    if (searchToAllFields) {
      const keywordsAllFields = this.$route.query[`filter[${searchToAllFields}]`];

      const keywordsAllFieldsObject = Array.isArray(keywordsAllFields) ? keywordsAllFields
        .map(keyword => ({ id: '', valor: keyword })) : [{ id: '', valor: keywordsAllFields }];
      
      this.searchKeywords = [
        ...this.searchKeywords,
        ...keywordsAllFieldsObject,
      ];
    }

  },
  mounted() {
    this.$vuetify.goTo(this.$refs['start-scroll']);
  },
  methods: {
    ...mapActions("job", ["retrieveJobs", "retrieveJob"]),
    changePage(input) {
      this.$vuetify.goTo(this.$refs['start-scroll']);
      this.$router.push({
        name: this.$route.params.id ? 'jobs by id' : 'jobs',
        params: this.$route.params,
        query: { ...this.$route.query, page: input }
      });
      this.getPageEvents();
    },
    getPageEvents() {
      this.loading = true;
      
      const { page, limit } = this.$route.query;
      const currentPage = parseInt(page) || 1;
      const currentLimit = parseInt(limit) || 10;
      store
        .dispatch("job/retrieveJobs", {
          ...this.$route.query,
          page: currentPage,
          limit: currentLimit,
        })
        .then(() => {
          this.page = currentPage;
          this.limit = currentLimit;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    selectJob(id) {      
      this.openDetailJob = true;
      this.dialogJobDetail = true;
      this.jobSelected = id;
      this.jobSelectedDetail = undefined;
      this.getPublicJobById(id);
    },
    async getPublicJobById(id) {
      this.loadingJob = true;
      this.isJobDetailError = false;
      store
        .dispatch("job/retrieveJob", id)
        .then(job => {
          this.jobSelectedDetail = job;
        })
        .catch(error => {
          this.isJobDetailError = true;
          // console.log(error.response);
        })
        .finally(() => {
          this.loadingJob = false;
        });
    },
    closeJobDetail() {
      this.openDetailJob = false;
      this.dialogJobDetail = false;
      this.jobSelected = undefined;
      this.jobSelectedDetail = undefined;
      this.isJobDetailError = false;
      this.$router.push({ name: 'jobs', query: this.$route.query })
    },
    timeElapsed(date) {
      return this.$moment(date).fromNow();
    },
    addFilter(filter, value) {
      this.searchKeywords.push({
        id: filter,
        valor: value,
      });
      this.applyFilters();
    },
    applyFilters() {
      const searchToAllFields = this.searchKeywords
        .filter(keyword => !keyword.id)
        .reduce((acc, el) => [ ...acc, el.valor ], []);
      
      const filters = this.searchKeywords
        .filter(keyword => keyword.id)
        .map(keyword => ({ [`filter[${keyword.id}]`]: keyword.valor }))
        .reduce((acc, el) => ({ ...acc, ...el }), {});
      
      this.$router.push({
        name: this.$route.params.id ? 'jobs by id' : 'jobs',
        params: this.$route.params,
        query: searchToAllFields.length
          ? { ...filters, [`filter[all]`]: searchToAllFields }
          : filters
        });
      this.getPageEvents();
    },
    deleteKeyword(index) {
      this.searchKeywords.splice(index, 1);
      this.applyFilters();
    },
    addKeyword() {
      const doesKeywordExists = this.searchKeywords
        .find(keyword => keyword.valor.toLowerCase() === this.keyword.toLowerCase());
      
      if (!doesKeywordExists) {
        this.searchKeywords.push({
          id: '',
          valor: this.keyword,
        });
        this.applyFilters();
      }

      this.keyword = '';
    },
  },
};
</script>
